import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Grid } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { useAppSelector } from "../../store/store";
import {
  anonymousUser,
  checkDependantQuestionTitle,
  checkDependantSummary,
  logErrorFunction,
} from "../../helper/service";
import SignInSignUpButton from "../../pages/payAndDownload/signInSignUpButton";
import BackDropLoader from "../loader/backDropLoader";

const SummaryScreen = (props: any) => {
  const { mainData, onClickLinkSummaryIDs, onClickUpdateInfoLink, formMainData, setShowRefresh } =
    props;
  const [loadings, setLoading] = useState<any>(false);
  const [summaryData, setSummaryData] = React.useState<any>([]);

  const { getSignleFormData, uiFormPayload }: any = useAppSelector(
    (state: any) => state?.formReducer
  );
  const { summaryList } = useAppSelector((state: any) => state?.documentReducer);
  const [formData, setFormData] = useState<any>({});

  useEffect(() => {
    setShowRefresh(true);
    return () => {
      setShowRefresh(false);
    };
  }, []);

  useEffect(() => {
    setFormData({ ...uiFormPayload });
  }, [uiFormPayload]);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  useEffect(() => {
    if (summaryList?.length && !loadings) {
      const nodeData = JSON.parse(getSignleFormData?.flowJson);
      const mainSectionData = nodeData?.nodes?.filter(
        (obj: any) =>
          obj?.parentNode === mainData?.parentNode &&
          obj?.data?.nodeTitle?.toLowerCase() !== "summary"
      );
      const tempData = mainSectionData
        ?.filter((obj: any) => checkDependantSummary(obj, formMainData))
        .map((obj: any) => {
          const sectiontemp = summaryList.filter(
            (object: any) => String(object?.sectionSummaryGroupKey) === String(obj?.id)
          );
          if (sectiontemp?.length) {
            return {
              ...obj,
              completePercentageData: {
                ...sectiontemp[0],
              },
            };
          }
          return {
            ...obj,
            completePercentageData: {
              missingFlowIds: [],
              percentComplete: 0,
              sectionKey: obj?.parentNode,
              sectionSummaryGroupKey: obj?.id,
            },
          };
        });
      setSummaryData(tempData);
    }
  }, [summaryList, getSignleFormData, loadings]);

  const showTitle = (data: any) => {
    const mainTiltle = checkDependantQuestionTitle(data, formData);
    return mainTiltle;
  };

  const onClickUpdate = (e: any, datas: any, index: any) => {
    if (datas?.missingFlowIds?.length > 0) {
      const idData = datas?.missingFlowIds?.[0];
      onClickUpdateInfoLink(e, idData, index);
    } else {
      logErrorFunction(
        `The ${datas?.sectionKey} section's ${datas?.sectionSummaryGroupKey} sectionsummarygroup have no missingFlowIds exist`
      );
    }
  };

  return (
    <div className="summary_screen_container">
      <div className="md:p-6 p-4 summary_screen_inner_container">
        <h1 className="text-black text-left text-lg font-bold leading-[120%] absolute top-[6%] summary_screen_header">
          Summary
        </h1>

        <div className="summaryList">
          {anonymousUser() ? (
            <Box
              alignItems="center"
              className="signin_up_btn_container"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              sx={{
                background: "#eff6fe",
                borderRadius: "12px",
                m: "0 auto",
              }}
            >
              <SignInSignUpButton />
            </Box>
          ) : (
            <>
              {summaryData &&
                summaryData?.length > 0 &&
                summaryData?.map((obj: any, index: any) => (
                  <Grid
                    className="section_summary_main_grid"
                    container
                    key={obj?.id}
                    spacing={2}
                    sx={{ padding: " 20px 0px" }}
                  >
                    <Grid className="section_summary_inner_grid" item mb={5} xs={12}>
                      <Box
                        className="section_summary_list_container"
                        id={obj?.id}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box className="section_summary_title_container">
                          <Typography
                            className="summary-title-responsive section_summary_title_txt"
                            component="div"
                            sx={{ fontWeight: "600", fontSize: "15px" }}
                            variant="h5"
                          >
                            {showTitle(obj)}
                          </Typography>
                        </Box>
                        <Box className="section_summary_btn_container" sx={{ display: "flex" }}>
                          {obj?.completePercentageData?.percentComplete < 100 && (
                            <Button
                              className="card-button update-missing-responsive update_missing_info_btn"
                              id={`${obj?.id}_missing_info_btn`}
                              onClick={(e: any) =>
                                onClickUpdate(e, obj?.completePercentageData, index)
                              }
                              sx={{ background: "#fef2f2", color: "#c23838" }}
                              variant="outlined"
                            >
                              <HelpOutlineOutlinedIcon
                                className="help-icon-responsive"
                                sx={{ mr: "4px" }}
                              />
                              Update missing info
                            </Button>
                          )}

                          {obj?.completePercentageData?.percentComplete === 100 && (
                            <>
                              <Button
                                className="card-button update-missing-responsive complete_summary_btn"
                                id={`complete_${obj?.completePercentageData?.sectionSummaryGroupKey}`}
                                sx={{ background: "#e9fbf0", color: "#2dac5d", cursor: "auto" }}
                                variant="outlined"
                              >
                                Complete
                              </Button>
                              <Button
                                className="card-button update-missing-responsive edit_summary_btn"
                                id={`edit_${obj?.completePercentageData?.sectionSummaryGroupKey}`}
                                onClick={(e: any) =>
                                  onClickLinkSummaryIDs(
                                    e,
                                    obj?.completePercentageData?.sectionSummaryGroupKey,
                                    index
                                  )
                                }
                                sx={{ background: "#eff6ff", color: "#2a66eb" }}
                                variant="outlined"
                              >
                                <EditOutlinedIcon sx={{ mr: "4px" }} />
                                Edit
                              </Button>
                            </>
                          )}
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                ))}
            </>
          )}
        </div>
      </div>
      {loadings && <BackDropLoader />}
    </div>
  );
};

export default SummaryScreen;
